import React from 'react';
import { ChangeCategoryPositionState } from './changeCategoryPositionState/ChangeCategoryPositionState';
import { ChangeCategoryPosition } from './components/ChangeCategoryPosition';

export const ChangeCategoryPositionPageV2: React.FC = () => {
	return (
		<ChangeCategoryPositionState>
			<ChangeCategoryPosition />
		</ChangeCategoryPositionState>
	);
};
